/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: CodeBlock[] = [];

    const project = feature.project;
    const NAME = feature.getSettingValue('NAME');
    const I2C = feature.getSettingValue('I2C');
    if (!I2C) {
        return blocks;
    }
    const I2CFeature = project.getFeature(I2C);
    const LCD_SCREEN_WIDGET_COLUMNS = feature.getSettingValue('LCD_SCREEN_WIDGET_COLUMNS');
    const LCD_SCREEN_WIDGET_ROWS = feature.getSettingValue('LCD_SCREEN_WIDGET_ROWS');
    const SDA = feature.getSettingValue('SDA');
    const SCL = feature.getSettingValue('SCL');
    // const GND = this.getSettingValue('GND');
    // const VCC = this.getSettingValue('VCC');
    const SCREENS = feature.getSettingValue('SCREENS');

    blocks.push({
        location: 'PRJ_CONF',
        template: `
CONFIG_LV_COLOR_DEPTH_1=y
CONFIG_LV_Z_BITS_PER_PIXEL=1
CONFIG_SSD1306=y
        `,
    });

    blocks.push({
        location: 'APP_OVERLAY',
        template: `
&${I2CFeature.getSettingValue('PORT')} {
    status = "okay";

    ssd1306_ssd1306_128x64: ssd1306@3c {
        compatible = "solomon,ssd1306fb";
        reg = <0x3c>;
        width = <${LCD_SCREEN_WIDGET_COLUMNS}>;
        height = <${LCD_SCREEN_WIDGET_ROWS}>;
        segment-offset = <0>;
        page-offset = <0>;
        display-offset = <0>;
        multiplex-ratio = <63>;
        segment-remap;
        com-invdir;
        prechargep = <0x22>;
    };
};
        `,
    });

    blocks.push({
        location: 'APP_OVERLAY_CHOSEN',
        template: `
zephyr,display = &ssd1306_ssd1306_128x64;`,
    });

    blocks.push({
        location: 'VARIABLE_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `const struct device *${NAME}_device;`,
    });

    blocks.push({
        location: 'PRJ_CONF',
        blockType: BlockType.CODE,
        template: `
CONFIG_LV_USE_THEME_DEFAULT=n
CONFIG_LV_USE_THEME_BASIC=y
CONFIG_LV_Z_VDB_SIZE=32
`,
    });

    return blocks;
};
